var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.16 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-workspace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,23.11H2a2,2,0,0,1-2-2V7.92a.44.44,0,0,1,.47-.47.44.44,0,0,1,.47.47V21.09a1,1,0,0,0,1,1H9.7a.44.44,0,0,1,.47.47A.55.55,0,0,1,9.66,23.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,29a.5.5,0,0,1-.66.14l-2-1.36-2,1.36A.47.47,0,0,1,2.67,29a.46.46,0,0,1,.14-.66L4.88,27V24h.94V27l2.06,1.36A.5.5,0,0,1,8,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.13,13.36V17h5.72a1.76,1.76,0,0,1,1.73,1.73v9.56a1.73,1.73,0,0,1-3.47,0V20.44H4.55A2.51,2.51,0,0,1,2.16,18V9.56a2.51,2.51,0,0,1,3.66-2.2h0c.47.33,2.67,2.44,4.5,4.22h3.09a1.73,1.73,0,0,1,0,3.47H9.61a1.85,1.85,0,0,1-1.17-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.55,3a3,3,0,1,1-6,0,3,3,0,1,1,6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.16,14.06v2.2a.44.44,0,0,1-.47.47H16a.47.47,0,0,1-.47-.47v-2.2a.47.47,0,0,1,.47-.47H28.69A.47.47,0,0,1,29.16,14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.16,17.58v12a.47.47,0,0,1-.47.47h-8.2a.47.47,0,0,1-.47-.47v-2.2a.47.47,0,0,1,.47-.47h5.25V17.67h3A1.39,1.39,0,0,0,29.16,17.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,2.16,20.39,11a.86.86,0,0,1-.84.56,1,1,0,0,1-.37,0L18,11a1,1,0,0,1-.52-1.22L21.14.94A1,1,0,0,1,22.36.42l1.17.52A.93.93,0,0,1,24,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.27,8.86l1.64-3.94A2.55,2.55,0,0,1,22.27,8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.22,12.61a.47.47,0,0,1-.47.47h-2.2a.47.47,0,1,1,0-.94h.61V9.56A4,4,0,0,0,24.09,9v3.19h.61A.48.48,0,0,1,25.22,12.61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsWorkspace);
export default __webpack_public_path__ + "static/media/icon-tutorials-workspace.efcb1c31f13719b0504ac131204ca9c6.svg";
export { ForwardRef as ReactComponent };